import React, { useState } from "react";
import axios from "axios";


const useHoliday = ({
    mainApi ="/shift_management/api/holiday/setting",
    onFinish = ({ axiosMode, status, values }) => { }, //
    onBefore = ({ axiosMode, status }) => { }, //
}) => {
    // const mainApi = `/shift_management/api/holiday/setting`
    const [data, setData] = useState([])
    const [newYearData, setNewYearData] = useState({
        data: [],
        total: 0,
        year: 2000
    })
    const getHolidaySettingData = (params) => {
        onBefore({
            axiosMode: "get"
        })
        return axios.get(mainApi, {
            params: params,
        })
            .then((response) => {
                let data = response.data
                setData(data?.data)
                if (data) {
                    onFinish(
                        {
                            axiosMode: "get",
                            status: "success",
                            values: data
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "get",
                            status: "error",
                            values: {
                                data: [],
                                total: 0
                            }
                        }
                    )
                }
                return {
                    ...data
                }
            });
    }
    const getHolidaySettingNewYear = () => {
        onBefore({
            axiosMode: "get"
        })
        return axios.get('/shift_management/api/holiday/new_year', {

        })
            .then((response) => {
                let data = response.data
                setNewYearData(data)
                if (data) {
                    onFinish(
                        {
                            axiosMode: "get",
                            status: "success",
                            values: data
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "get",
                            status: "error",
                            values: {
                                data: [],
                                total: 0
                            }
                        }
                    )
                }

                return {
                    ...data
                }
            });
    }
    const postHolidaySettingData = (data) => {
        onBefore({
            axiosMode: "post"
        })
        axios.post('/shift_management/api/holiday/new_year',
            data
        )
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                if (status === "success") {
                    onFinish(
                        {
                            axiosMode: "post",
                            status: "success"
                        }
                    )

                }
                else {
                    onFinish(
                        {
                            axiosMode: "post",
                            status: "error"
                        }
                    )
                }
            })
            .catch(() => {
                onFinish(
                    {
                        axiosMode: "post",
                        status: "error"
                    }
                )
            })
    }
    const patchHolidaySettingData = (data) => {
        onBefore({
            axiosMode: "patch"
        })
        axios.patch(mainApi,
            data

        )
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                if (status === "fail") {
                    onFinish(
                        {
                            axiosMode: "patch",
                            status: "error"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "patch",
                            status: "success"
                        }
                    )
                }
            })
            .catch(() => {
                onFinish(
                    {
                        axiosMode: "patch",
                        status: "error"
                    }
                )
            })
    }
    const deleteHolidaySettingData = (data) => {
        onBefore({
            axiosMode: "delete"
        })
        axios.delete(mainApi,
            {
                data
            }
        )
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                if (status === "success") {
                    onFinish(
                        {
                            axiosMode: "delete",
                            status: "success"
                        }
                    )

                }
                else {
                    onFinish(
                        {
                            axiosMode: "delete",
                            status: "error"
                        }
                    )
                }

            })
            .catch(() => {
                onFinish(
                    {
                        axiosMode: "delete",
                        status: "error"
                    }
                )
            })
    }
    return {
        HolidaySettingDatas: data,
        HolidaySettingNewYearDatas: newYearData,
        getHolidaySettingNewYear,
        getHolidaySettingData,
        postHolidaySettingData,
        patchHolidaySettingData,
        deleteHolidaySettingData,
    }
}
export { useHoliday }
